import { render, staticRenderFns } from "./MailCreatePdfFormPage.vue?vue&type=template&id=474baa92&scoped=true&"
import script from "./MailCreatePdfFormPage.vue?vue&type=script&lang=js&"
export * from "./MailCreatePdfFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474baa92",
  null
  
)

export default component.exports